import { render, staticRenderFns } from "./ExternalChangesInfoSection.vue?vue&type=template&id=2d3a8c78&scoped=true&"
import script from "./ExternalChangesInfoSection.vue?vue&type=script&lang=js&"
export * from "./ExternalChangesInfoSection.vue?vue&type=script&lang=js&"
import style0 from "./ExternalChangesInfoSection.vue?vue&type=style&index=0&id=2d3a8c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3a8c78",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
